import { render, staticRenderFns } from "./StartupForm.vue?vue&type=template&id=53426a39&"
import script from "./StartupForm.vue?vue&type=script&lang=js&"
export * from "./StartupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports